import { createI18n } from "vue-i18n";
import datetimeFormats from "../locales/datetimeFormats";
import i18nService from "../services/i18n.service";
import moment from "moment";

const langauge = await i18nService.getLocale();
const messages = await i18nService.geti18nMessages(langauge.id);
const polishMessages = await i18nService.geti18nMessages(1);
const i18n = createI18n({
    legacy: false,
    locale: langauge.code,
    fallbackLocale: "pl",
    messages: {
        pl: polishMessages.data
    },
    datetimeFormats
});

i18n.global.setLocaleMessage(langauge.code, messages.data);
moment.locale(langauge.code)

export default i18n;